import { useEffect, useState } from 'react'
import { prettyLog } from '../../../utils'

interface ManifestData {
  manifestUrl: string | null
  trackingUrl: string | null
}

export type IUseLiveSourceManifest = {
  source: string
  provider: 'gmana' | 'kaltura'
} | null

export function useLiveSourceManifest(
  props: IUseLiveSourceManifest
): ManifestData {
  const [manifestUrl, setManifestUrl] = useState<string | null>(null) // State to hold the URL of the media sodata
  const [trackingUrl, setTrackingUrl] = useState<string | null>(null) // State to hold the URL used for ad tracking data

  useEffect(() => {
    if (props) {
      const { source, provider } = props
      const fetchManifestAndTracking = async () => {
        try {
          const resp = await fetch(source, { method: 'POST' })
          if (!resp.ok) {
            throw new Error('POST failed: ' + resp.status)
          }
          const data = await resp.json()
          if (data.manifestUrl && data.trackingUrl) {
            try {
              const manifestUrlResolved = new URL(data.manifestUrl, source).href
              const trackingUrlResolved = new URL(data.trackingUrl, source).href
              setManifestUrl(manifestUrlResolved)
              setTrackingUrl(trackingUrlResolved)
            } catch (e) {
              prettyLog(
                'Source POST failed:',
                'missing manifestUrl or trackingUrl',
                'error'
              )
            }
          } else {
            prettyLog(
              'Source POST failed:',
              'missing manifestUrl or trackingUrl',
              'error'
            )
          }
        } catch (e) {
          prettyLog('Source POST failed: ', e, 'error')
          setManifestUrl(source)
          setTrackingUrl(null)
        }
      }
      if (provider === 'gmana') {
        fetchManifestAndTracking()
      } else {
        setManifestUrl(source)
        setTrackingUrl(null)
      }
    }
  }, [props])

  return { manifestUrl, trackingUrl }
}
